export default class  SalesTargetReportActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_SALESTARGETREPORT='GET_HELPER_SALESTARGETREPORT';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static BEFORE_PRINT_SALESTARGETREPORT='BEFORE_PRINT_SALESTARGETREPORT';
  static PRINT_SALESTARGETREPORT='PRINT_SALESTARGETREPORT';
  static submit(){
    return {
      type:  SalesTargetReportActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type:  SalesTargetReportActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type:  SalesTargetReportActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type:  SalesTargetReportActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type:  SalesTargetReportActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type:  SalesTargetReportActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type:  SalesTargetReportActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type:  SalesTargetReportActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type:  SalesTargetReportActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type:  SalesTargetReportActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type:  SalesTargetReportActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type:  SalesTargetReportActions.GET_HELPER_SALESTARGETREPORT,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type:  SalesTargetReportActions.ERROR_SERVER,
      payload: error
    };
  }
  static beforePrint(){
    return {
      type: SalesTargetReportActions.BEFORE_PRINT_SALESTARGETREPORT,
    };
  }
  static print(printSalesTargetReport){
    return {
      type: SalesTargetReportActions.PRINT_SALESTARGETREPORT,
      payload: printSalesTargetReport
    };
  }
}